import { type FileItem, type FileResult, type UploadState } from '../models/files';

export function dataURLtoBlob(dataUrl?: string | null): Blob {
  if (!dataUrl) {
    throw new Error('Data URL missing');
  }

  const arr = dataUrl.split(',');
  const mimeType = arr[0].match(/:(.*?);/)?.[1];
  const bstr = atob(arr[1]);

  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mimeType });
}

export function getUploadStateKey(
  fileItem: FileItem,
): keyof Pick<FileItem, 'upload' | 'uploadEdited'> {
  return fileItem.cropData ? 'uploadEdited' : 'upload';
}

export function getUploadState(fileItem: FileItem): UploadState | undefined {
  return fileItem[getUploadStateKey(fileItem)];
}

export function isFileResult(data: any): data is FileResult {
  return data && typeof data === 'object' && 'filename' in data && 'url' in data;
}
